// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"354":"9da0be4f9c43a3f006d6","418":"5ea7ad59263273b32997","780":"b8f0e2041d914e8ee550"}[chunkId] + ".chunk.js";
};